import { render, staticRenderFns } from "./NotCorrectPayLinkKey.vue?vue&type=template&id=68e5354a&scoped=true&"
import script from "./NotCorrectPayLinkKey.vue?vue&type=script&lang=js&"
export * from "./NotCorrectPayLinkKey.vue?vue&type=script&lang=js&"
import style0 from "./NotCorrectPayLinkKey.vue?vue&type=style&index=0&id=68e5354a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5354a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
